// section : product page accordion 
 document.addEventListener('DOMContentLoaded', function() {
  const accordionItems = document.querySelectorAll('.accordion-item');
  const isMobile = window.innerWidth <= 768;

  function updateImageContent(item) {
    const imageContainer = document.querySelector('.accordion_col-right .image-container img');
    const imageTitle = document.querySelector('.accordion_col-right .image-title');
    const imageDescription = document.querySelector('.accordion_col-right .image-description');

    const imageSrc = item.getAttribute('data-image-src');
    const title = item.getAttribute('data-title');
    const description = item.getAttribute('data-description');
    const descriptionLink = item.getAttribute('data-description-link');

    imageContainer.setAttribute('src', imageSrc);
    imageTitle.textContent = title;
    if (descriptionLink) {
      imageDescription.innerHTML = `<a href="${descriptionLink}">${description}  <svg width="49" height="8" viewBox="0 0 49 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M48.3536 4.35355C48.5488 4.15829 48.5488 3.84171 48.3536 3.64645L45.1716 0.464466C44.9763 0.269204 44.6597 0.269204 44.4645 0.464466C44.2692 0.659728 44.2692 0.976311 44.4645 1.17157L47.2929 4L44.4645 6.82843C44.2692 7.02369 44.2692 7.34027 44.4645 7.53553C44.6597 7.7308 44.9763 7.7308 45.1716 7.53553L48.3536 4.35355ZM0 4.5H48V3.5H0V4.5Z" fill="#231F20"></path></svg></a>`;
    } else {
      imageDescription.textContent = description;
    }
  }

  if (accordionItems.length > 0) {
    // Open the first accordion item by default
    const firstItem = accordionItems[0];
    firstItem.classList.add('active');
    firstItem.querySelector('.accordion-content').style.display = 'block';
    updateImageContent(firstItem);

    if (isMobile) {
      firstItem.querySelector('.image-container').style.display = 'block';
    } else {
      updateImageContent(firstItem);
    }
  }

  accordionItems.forEach(item => {
    const header = item.querySelector('.accordion-header');
    const content = item.querySelector('.accordion-content');

    header.addEventListener('click', () => {
      if (!item.classList.contains('active')) {
        accordionItems.forEach(otherItem => {
          otherItem.classList.remove('active');
          otherItem.querySelector('.accordion-content').style.display = 'none';
          if (isMobile) {
            otherItem.querySelector('.image-container').style.display = 'none';
          }
        });

        item.classList.add('active');
        content.style.display = 'block';
        if (isMobile) {
          item.querySelector('.image-container').style.display = 'block';
        }
        updateImageContent(item);
      }
    });
  });
});
